import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Menu } from '@mui/icons-material';
import { AppBar, Box, Icon, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { useAppState } from 'shared/stores';
import { BelnickLogo } from '../logos';

export function Header() {
    const { instance } = useMsal();
    const authenticated = useIsAuthenticated();
    const appState = useAppState();

    const logout = () => {
        instance.logout();
    };

    const toggle = () => {
        appState.sideDrawerOpen.set(prev => !prev);
    };

    const openSupportPortal = () =>
        window.open(
            'https://insight2profit.atlassian.net/servicedesk/customer/portal/10',
            '_blank',
            'noopener,noreferrer'
        );

    return (
        <AppBar position='static'>
            <Toolbar sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
                <Box justifySelf='start'>
                    <IconButton color='inherit' aria-label='menu' onClick={toggle} size='large'>
                        <Menu />
                    </IconButton>
                </Box>
                <Box justifySelf='center'>
                    <BelnickLogo />
                </Box>
                <Box justifySelf='end'>
                    {authenticated && (
                        <Box display='flex' gap={2} alignItems='center'>
                            <Typography variant='body2'>Welcome, {appState.user.get()?.displayName}</Typography>
                            <div>
                                <Tooltip title='Customer Support'>
                                    <IconButton color='inherit' onClick={openSupportPortal} size='large'>
                                        <HelpOutlineOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Logout'>
                                    <IconButton color='inherit' onClick={logout} size='large'>
                                        <Icon>logout</Icon>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </Box>
                    )}
                </Box>
            </Toolbar>
        </AppBar>
    );
}
